import { Editor, Location, Path, Point, Range, Transforms } from 'slate';
import isValidPoint from '@atlas/tool/box/slate/isValidPoint';
import isValidRange from '@atlas/tool/box/slate/isValidRange';

export default function changeEditorSelection(editor: Editor, target: Location) {
    const isInvalidPath = Path.isPath(target) && !isValidPoint(editor, { path: target, offset: 0 });
    const isInvalidPoint = Point.isPoint(target) && !isValidPoint(editor, target);
    const isInvalidRange = Range.isRange(target) && !isValidRange(editor, target);

    if (isInvalidPath || isInvalidPoint || isInvalidRange) {
        console.error('Selection cannot be changed, target is invalid', target);
        return;
    }

    Transforms.select(editor, target);
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('changeEditorSelection', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
